<div class="flex flex-col md:flex-row min-h-screen bg-white">
  <app-sidebar [circleNumber]="3" (backClick)="goBack()" class="bg-teu-purple hidden sm:block relative w-full md:w-[197px] h-[120px] md:h-auto flex-shrink-0 overflow-hidden"></app-sidebar>
  <app-header [circleNumber]="3" (backClick)="goBack()"></app-header>

  <div class="flex-1 flex flex-col">
    <app-subheader [circleNumber]="2" class="pt-[60px] md:pt-0"></app-subheader>

    <div class="w-full xl:max-w-[1240px] 2xl:max-w-[1300px] mx-auto xl:mx-0 px-4 sm:px-6 md:px-8 xl:px-7 pb-28 md:pb-16 xl:pb-10"
         style="padding-bottom: calc(env(safe-area-inset-bottom, 0px) + 88px);">
      <h1 class="teu-title text-2xl md:text-[32px] mb-2 md:mb-4 text-center md:text-left">
        Referencias personales <span class="block md:inline font-normal">(Contacto 2)</span>
      </h1>
      <p class="teu-subtitle text-lg md:text-xl mb-8 md:mb-12 text-center md:text-left">
        Selecciona 2 contactos de tu agenda, conocido con quien no compartas domicilio
      </p>

      <form [formGroup]="personalReferenceForm" (ngSubmit)="onSubmit()" class="grid grid-cols-1 md:grid-cols-3 gap-x-6 gap-y-5 md:gap-y-8">
        <!-- Fila 1 -->
        <div class="flex flex-col">
          <p-inputMask
            formControlName="cellPhone"
            mask="+52 99 9999 9999"
            [unmask]="true"
            [slotChar]="'_'"
            [autoClear]="false"
            [styleClass]="'w-full md:max-w-[300px]' + (isFieldInvalid('cellPhone') ? ' ng-invalid ng-dirty' : '')"
            placeholder="Tel Celular"
            inputmode="numeric"
          ></p-inputMask>
          <small *ngIf="isFieldInvalid('cellPhone')" class="text-red-500 mt-1">{{ getFieldError('cellPhone') }}</small>
        </div>
        <div class="flex flex-col">
          <input pInputText type="text" formControlName="names"
                 [class]="'w-full md:max-w-[300px]' + (isFieldInvalid('names') ? ' ng-invalid ng-dirty' : '')"
                 placeholder="Nombre(s)" />
          <small *ngIf="isFieldInvalid('names')" class="text-red-500 mt-1">{{ getFieldError('names') }}</small>
        </div>
        <div class="flex flex-col">
          <input pInputText type="text" formControlName="lastNameP"
                 [class]="'w-full md:max-w-[300px]' + (isFieldInvalid('lastNameP') ? ' ng-invalid ng-dirty' : '')"
                 placeholder="Apellido paterno" />
          <small *ngIf="isFieldInvalid('lastNameP')" class="text-red-500 mt-1">{{ getFieldError('lastNameP') }}</small>
        </div>

        <!-- Fila 2 -->
        <div class="flex flex-col">
          <input pInputText type="text" formControlName="lastNameM"
                 [class]="'w-full md:max-w-[300px]' + (isFieldInvalid('lastNameM') ? ' ng-invalid ng-dirty' : '')"
                 placeholder="Apellido materno" />
          <small *ngIf="isFieldInvalid('lastNameM')" class="text-red-500 mt-1">{{ getFieldError('lastNameM') }}</small>
        </div>
        <div class="flex flex-col">
          <p-dropdown [options]="relationOptions" optionLabel="label" optionValue="value"
                      formControlName="relation"
                      [styleClass]="'w-full md:max-w-[300px]' + (isFieldInvalid('relation') ? ' ng-invalid ng-dirty' : '')"
                      placeholder="Relación"></p-dropdown>
          <small *ngIf="isFieldInvalid('relation')" class="text-red-500 mt-1">{{ getFieldError('relation') }}</small>
        </div>
        <div class="flex flex-col">
          <p-dropdown [options]="yearsKnownOptions" optionLabel="label" optionValue="value"
                      formControlName="yearsKnown"
                      [styleClass]="'w-full md:max-w-[300px]' + (isFieldInvalid('yearsKnown') ? ' ng-invalid ng-dirty' : '')"
                      placeholder="Años de conocerse"></p-dropdown>
          <small *ngIf="isFieldInvalid('yearsKnown')" class="text-red-500 mt-1">{{ getFieldError('yearsKnown') }}</small>
        </div>

        <!-- Fila 3 -->
        <div class="flex flex-col">
          <p-inputMask
            formControlName="phone"
            mask="99 9999 9999"
            [unmask]="true"
            [slotChar]="'_'"
            [autoClear]="false"
            [styleClass]="'w-full md:max-w-[300px]' + (isFieldInvalid('phone') ? ' ng-invalid ng-dirty' : '')"
            placeholder="Teléfono fijo"
            inputmode="numeric"
          ></p-inputMask>
          <small *ngIf="isFieldInvalid('phone')" class="text-red-500 mt-1">{{ getFieldError('phone') }}</small>
        </div>
        <div class="flex flex-col">
          <input pInputText type="text" formControlName="contactSchedule"
                 [class]="'w-full md:max-w-[300px]' + (isFieldInvalid('contactSchedule') ? ' ng-invalid ng-dirty' : '')"
                 placeholder="Horario de contacto" />
          <small *ngIf="isFieldInvalid('contactSchedule')" class="text-red-500 mt-1">{{ getFieldError('contactSchedule') }}</small>
        </div>
        <div class="hidden md:block"></div>

        <!-- Domicilio -->
        <div class="md:col-span-3 mt-2">
          <span class="block text-sm text-black font-medium">Domicilio</span>
        </div>

        <!-- Formulario anidado para dirección -->
        <ng-container formGroupName="address">
          <!-- Fila domicilio 1 -->
          <div class="flex flex-col">
            <input pInputText type="text" formControlName="street"
                   [class]="'w-full md:max-w-[300px]' + (isFieldInvalid('address.street') ? ' ng-invalid ng-dirty' : '')"
                   placeholder="Calle" />
            <small *ngIf="isFieldInvalid('address.street')" class="text-red-500 mt-1">{{ getFieldError('address.street') }}</small>
          </div>
          <div class="flex flex-col">
            <div class="grid grid-cols-2 gap-3 md:max-w-[300px]">
              <div>
                <input pInputText type="text" formControlName="extNumber"
                       [class]="isFieldInvalid('address.extNumber') ? 'ng-invalid ng-dirty' : ''"
                       placeholder="No.Exterior" />
                <small *ngIf="isFieldInvalid('address.extNumber')" class="text-red-500 mt-1 text-xs">{{ getFieldError('address.extNumber') }}</small>
              </div>
              <div>
                <input pInputText type="text" formControlName="intNumber" placeholder="No.Interior" />
              </div>
            </div>
          </div>
          <div class="flex flex-col">
            <input pInputText type="text" formControlName="postalCode"
                   [class]="'w-full md:max-w-[300px]' + (isFieldInvalid('address.postalCode') ? ' ng-invalid ng-dirty' : '')"
                   placeholder="Código Postal"
                   (input)="onPostalCodeChange()" />
            <small *ngIf="isFieldInvalid('address.postalCode')" class="text-red-500 mt-1">{{ getFieldError('address.postalCode') }}</small>
          </div>

          <!-- Fila domicilio 2 -->
          <div class="flex flex-col">
            <p-dropdown [options]="colonyOptions" optionLabel="label" optionValue="value"
                        formControlName="neighborhood"
                        [styleClass]="'w-full md:max-w-[300px]' + (isFieldInvalid('address.neighborhood') ? ' ng-invalid ng-dirty' : '')"
                        placeholder="Colonia"></p-dropdown>
            <small *ngIf="isFieldInvalid('address.neighborhood')" class="text-red-500 mt-1">{{ getFieldError('address.neighborhood') }}</small>
          </div>
          <div class="flex flex-col">
            <p-dropdown [options]="municipalityOptions" optionLabel="label" optionValue="value"
                        formControlName="municipality"
                        [styleClass]="'w-full md:max-w-[300px]' + (isFieldInvalid('address.municipality') ? ' ng-invalid ng-dirty' : '')"
                        placeholder="Delegación/Municipio"></p-dropdown>
            <small *ngIf="isFieldInvalid('address.municipality')" class="text-red-500 mt-1">{{ getFieldError('address.municipality') }}</small>
          </div>
          <div class="flex flex-col">
            <input pInputText type="text" formControlName="state"
                   [class]="'w-full md:max-w-[300px]' + (isFieldInvalid('address.state') ? ' ng-invalid ng-dirty' : '')"
                   placeholder="Estado" />
            <small *ngIf="isFieldInvalid('address.state')" class="text-red-500 mt-1">{{ getFieldError('address.state') }}</small>
          </div>

          <!-- Fila domicilio 3 -->
          <div class="flex flex-col">
            <p-dropdown [options]="housingTypeOptions" optionLabel="label" optionValue="value"
                        formControlName="housingType"
                        [styleClass]="'w-full md:max-w-[300px]' + (isFieldInvalid('address.housingType') ? ' ng-invalid ng-dirty' : '')"
                        placeholder="Tipo de vivienda"></p-dropdown>
            <small *ngIf="isFieldInvalid('address.housingType')" class="text-red-500 mt-1">{{ getFieldError('address.housingType') }}</small>
          </div>
          <div class="flex flex-col">
            <input pInputText type="number" formControlName="yearsResidence"
                   [class]="'w-full md:max-w-[300px]' + (isFieldInvalid('address.yearsResidence') ? ' ng-invalid ng-dirty' : '')"
                   placeholder="Años de residencia" />
            <small *ngIf="isFieldInvalid('address.yearsResidence')" class="text-red-500 mt-1">{{ getFieldError('address.yearsResidence') }}</small>
          </div>
          <div class="hidden md:block"></div>
        </ng-container>

        <!-- Botón -->
        <div class="md:col-span-1 md:col-start-1 md:row-start-8 md:mt-20 lg:mt-24 xl:mt-28">
          <button type="submit"
                  [disabled]="personalReferenceForm.invalid"
                  [class]="'btn-primary w-full md:w-[300px] h-[46px]' + (personalReferenceForm.invalid ? ' opacity-50 cursor-not-allowed' : '')">
            Confirmar
          </button>
        </div>
      </form>
    </div>
  </div>
</div>